import type {
  CreateProfileRequest,
  CreateProfileResponse,
  ProfileSwitchResponse,
  UserProfile,
} from '../types/user'
import { api } from './fetch'

export const profileService = {
  /**
   * Get all profiles for a user
   */
  async getUserProfiles(userId: number): Promise<UserProfile[]> {
    const response = await api.get(`/user/${userId}/profiles/`)
    return response.data
  },

  /**
   * Switch to a different profile
   */
  async switchProfile(
    userId: number,
    profileId: number,
  ): Promise<ProfileSwitchResponse> {
    const response = await api.post(
      `/user/${userId}/switch-profile/${profileId}/`,
    )
    return response.data
  },

  /**
   * Create a new stakeholder profile for user
   */
  async createProfile(
    userId: number,
    profileData: CreateProfileRequest,
  ): Promise<CreateProfileResponse> {
    const response = await api.post(`/user/${userId}/profiles/`, profileData)
    return response.data
  },
}
